<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance"
         id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close">
          <i class="icon-close"></i>
        </button>
        <div class="modal__header modal_ti_header"></div>
        <div class="modal__body">
          <h1>{{ getTranslations.home_modals_confirm_purchase_purchase }}</h1>
          <img class="modal_icon_alert"
               src="static/images/modals/confirm_purchase.png">
          <p class="modal_strong">
            {{ getBundleData.numberOfCoins }} {{ getTranslations.home_modals_confirm_purchase_games }} – {{ getBundleData.price}} {{ getBundleData.currencyCode }}</p>
          <p>{{ getTranslations.home_modals_confirm_purchase_via_sms_playing_more }}</p>
          <p>{{ getTranslations.home_modals_confirm_purchase_via_sms_purchase_now_by }}</p>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters } from 'vuex';

export default {
  name: 'confirmPurchaseViaSms',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ConfirmPurchaseViaSms.vue